import { useOktaAuth } from "@okta/okta-react";

export function useOkta() {
  const { oktaAuth, authState } = useOktaAuth() || {};

  const logout = async () => {
    if (authState?.isAuthenticated === true) {
      // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
      await oktaAuth.signOut();
    }
  };

  return {
    logout,
  };
}
